import { render } from "./SpaceFormPageOne.vue?vue&type=template&id=410e5edf"
import script from "./SpaceFormPageOne.vue?vue&type=script&lang=js"
export * from "./SpaceFormPageOne.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "410e5edf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('410e5edf', script)) {
    api.reload('410e5edf', script)
  }
  
  module.hot.accept("./SpaceFormPageOne.vue?vue&type=template&id=410e5edf", () => {
    api.rerender('410e5edf', render)
  })

}

script.__file = "src/components/dashboard/space-form-pages/SpaceFormPageOne.vue"

export default script